// uk marketing copy. Mirrors the EN source 1:1 (see types.ts).
import type { MkPack } from './types'

const pack: MkPack = {
  "features": {
    "custom-domains": {
      "name": "Власні домени",
      "title": "Власні домени для електронного підпису",
      "desc": "Електронний підпис на вашому домені, наприклад sign.vashafirma.com. Один запис CNAME, а перевірку DNS і сертифікат TLS ми робимо автоматично.",
      "h1": "Ваш домен, ваш бренд, наш механізм підписання",
      "lead": "Одержувачі відкривають посилання на підпис на sign.vashafirma.com, а не на нашому домені. Кожна організація отримує власний перевірений домен з автоматичним сертифікатом TLS на спільній платформі.",
      "sections": [
        {
          "h2": "Налаштування за кілька хвилин",
          "body": "Додайте домен у налаштуваннях організації та створіть один запис CNAME у свого DNS-провайдера. Щойно запис почне резолвитися, sign.yt перевірить його та випустить сертифікат Let's Encrypt під час першого запиту.\n\nЖодного окремого розгортання, жодних файлів сертифікатів, які треба завантажувати чи поновлювати."
        },
        {
          "h2": "Кожен запит потрапляє до потрібної організації",
          "body": "Платформа визначає організацію за заголовком Host кожного запиту. Сторінки підписання, листи та екран входу на вашому домені показують ваш логотип і кольори, а дані ніколи не перетинаються між клієнтами."
        },
        {
          "h2": "Створено для операторів із багатьма брендами",
          "body": "Віртуальні офіси, коворкінги та бухгалтерські компанії часто мають кілька брендів. Кожна організація може мати власний домен, брендинг і відправника листів, а ви керуєте всім з одного облікового запису."
        }
      ],
      "faq": [
        {
          "q": "Які тарифи включають власний домен?",
          "a": "Власні домени доступні починаючи з тарифу Professional."
        },
        {
          "q": "Чи потрібно мені керувати сертифікатами TLS?",
          "a": "Ні. Сертифікати випускаються та поновлюються автоматично, щойно ваш запис DNS вказує на платформу."
        },
        {
          "q": "Чи можна й далі користуватися адресою sign.yt?",
          "a": "Так. Посилання на домені платформи продовжують працювати; власний домен є доповненням, а не міграцією."
        },
        {
          "q": "Чи посилання для перевірки теж використовують мій домен?",
          "a": "QR-код і коротке посилання на кожному підписаному документі за замовчуванням ведуть на verify.sign.yt. Перенесення їх на ваш домен входить до платного доповнення Full customization."
        }
      ]
    },
    "white-label-branding": {
      "name": "Власний бренд (white label)",
      "title": "Власний бренд для електронного підпису",
      "desc": "Ваш логотип, кольори та одна з чотирьох тем на кожній сторінці підписання, сторінці перевірки та в листах. Команди можуть мати власний вигляд.",
      "h1": "Сторінки підписання, що виглядають як ваша компанія",
      "lead": "Одержувачі бачать ваш логотип, ваші кольори та вашу назву від першого листа до підписаного PDF. sign.yt залишається на задньому плані.",
      "sections": [
        {
          "h2": "Ваш бренд у кожній точці контакту",
          "body": "Завантажте логотип, задайте назву бренду та основний колір, і одержувачі побачать їх на сторінці підписання та на публічній сторінці перевірки кожного підписаного документа. Ті самі налаштування застосовуються до листів-сповіщень разом з іменем відправника та підписом у футері листа. Сторінка входу також приймає favicon, додатковий колір і короткий вітальний текст.\n\nОберіть одну з чотирьох тем сторінки: класичну, мінімалістичну, темну або виразну. Кожна тема працює з кольором вашого бренду і за потреби коригує його, щоб текст зберігав читабельний контраст.\n\nОдержувачі впізнають, хто просить їх підписати, а це будує довіру та зменшує кількість запитань «це не фішинг?», на які доводиться відповідати вашій команді."
        },
        {
          "h2": "Окремий вигляд для кожної команди",
          "body": "Маєте кілька локацій чи брендів в одній організації? Кожна команда може змінити логотип, кольори, тему та ім'я відправника. Документ, надісланий командою, показує її вигляд на сторінці підписання, на сторінці перевірки та в листах, тож договір з офісу у Варшаві виглядає інакше, ніж надісланий у Кракові.\n\nКоли потрібна однаковість, адміністратор організації може заблокувати брендинг команд одним перемикачем, і всі команди всюди повертаються до вигляду організації."
        },
        {
          "h2": "Без значка платформи на платних тарифах",
          "body": "На тарифі Starter сторінки входу та організації показують невелику примітку «Powered by sign.yt». Починаючи з тарифу Professional вона зникає, і досвід повністю ваш. Поєднайте це з власним доменом, і одержувачі підписуватимуть на вашій адресі, а sign.yt залишиться на задньому плані.\n\nКожен підписаний документ містить QR-код і коротке посилання, наприклад verify.sign.yt/k3Fq9ZxT2mPa7LwB, на свою публічну сторінку перевірки. З платним доповненням Full customization ці посилання також використовують ваш власний домен.\n\nБрендинг визначається в одному місці, від команди до організації і до стандартних налаштувань платформи, тому листи, сторінки підписання та сторінки перевірки залишаються узгодженими без ручного копіювання налаштувань."
        }
      ],
      "faq": [
        {
          "q": "Що можна налаштувати?",
          "a": "Логотип, назву бренду, основний колір, тему сторінки, ім'я відправника та футер листів. Сторінка входу також приймає favicon, додатковий колір і вітальний текст."
        },
        {
          "q": "Які теми сторінок можна обрати?",
          "a": "Чотири: класичну, мінімалістичну, темну та виразну. Тема застосовується до сторінки підписання та публічної сторінки перевірки."
        },
        {
          "q": "Чи може кожна команда мати власний брендинг?",
          "a": "Так. Команда може змінити логотип, кольори, тему та ім'я відправника. Її документи показують цей вигляд на сторінці підписання, сторінці перевірки та в листах, якщо адміністратор не заблокував брендинг команд для всієї організації."
        },
        {
          "q": "Чи застосовується брендинг і до листів?",
          "a": "Так. Листи-сповіщення використовують брендинг організації або налаштування команди, якщо вони є, зокрема ім'я відправника та футер."
        },
        {
          "q": "Де з'являється «Powered by sign.yt»?",
          "a": "Лише на тарифі Starter, на сторінках входу та організації. Тарифи Professional і вищі його прибирають."
        },
        {
          "q": "Куди ведуть посилання для перевірки?",
          "a": "За замовчуванням на verify.sign.yt, коротку адресу, що відкриває сторінку перевірки документа у вашому брендингу. Посилання для перевірки на вашому власному домені входять до платного доповнення Full customization."
        }
      ]
    },
    "pades-electronic-signature": {
      "name": "Підписи PAdES",
      "title": "Електронний підпис PAdES для кожного PDF",
      "desc": "Кожен підписант отримує криптографічний підпис PAdES у PDF, а документ ще й печатку платформи та сертифікат завершення. Будь-яку зміну видно.",
      "h1": "Криптографічна печатка, а не просто зображення підпису",
      "lead": "sign.yt не просто вставляє намальований підпис на сторінку. Кожен підпис вбудовується в PDF як підпис PAdES, тож будь-яку пізнішу зміну файлу можна виявити.",
      "sections": [
        {
          "h2": "Окремий підпис PAdES для кожного підписанта",
          "body": "Коли одержувач завершує підписання, sign.yt накладає інкрементальний підпис PAdES із сертифікатом, виданим для цього підписанта центром сертифікації платформи. Підписи додаються один за одним, тому попередні залишаються дійсними.\n\nНові ключі використовують ECDSA P-384 із SHA-384. Коли всі сторони підписали, документ закриває фінальна печатка платформи.\n\nКожен підписант має власний запис на панелі підписів PDF зі своїм ім'ям і часом підписання, а не один анонімний штамп на весь документ."
        },
        {
          "h2": "Довірений час і довгострокова перевірка",
          "body": "sign.yt може додати до кожного підпису позначку часу RFC 3161 від служби позначок часу. Якщо позначку часу налаштовано, фінальна печатка доповнюється даними для перевірки та позначкою часу документа (PAdES-B-LTA), тож підпис можна буде перевірити й через багато років.\n\nБез служби позначок часу підписи створюються на базовому рівні PAdES-B-B. В обох випадках підпис охоплює кожен байт документа в тому вигляді, який він мав у цей момент."
        },
        {
          "h2": "Перевірка поза sign.yt",
          "body": "Підписаний файл є стандартним PDF. Adobe Acrobat Reader та інші програми для PDF із підтримкою підписів показують підписи та позначають будь-яку зміну, внесену після підписання.\n\nБудь-хто також може завантажити PDF у публічний верифікатор sign.yt без облікового запису, щоб побачити, хто підписав, коли і чи байти не змінені.\n\nВерифікатор перевіряє, чи підпис охоплює весь файл і чи документ має печатку платформи sign.yt. Якщо увімкнено валідатор EU DSS, він також показує висновок eIDAS для кожного підпису.\n\nКожен завершений документ отримує QR-код і коротку адресу verify.sign.yt у сертифікаті завершення. Вона відкриває публічну сторінку з маскованими іменами підписантів, датами підписання, фінальним хешем, печаткою та статусом закріплення в Bitcoin і дає змогу будь-кому перевірити, що його копія файлу ідентична."
        },
        {
          "h2": "Докази, додані до документа",
          "body": "До підписаного PDF додається сертифікат завершення. Для кожного підписанта він містить email, метод перевірки, час надсилання, перегляду та підписання, IP-адресу та user agent, а також текст згоди, яку людина позначила перед підписанням. Докази подорожують разом із файлом, а не лише зберігаються в нашій базі даних.\n\nХеш фінального PDF також закріплюється в Bitcoin через OpenTimestamps, а весь пакет можна завантажити як один ZIP-архів із доказами.\n\nЯкщо підпис колись поставлять під сумнів, у вас буде все в одному файлі, який можна передати юристу, аудитору чи суду."
        }
      ],
      "faq": [
        {
          "q": "Чи має підпис sign.yt юридичну силу?",
          "a": "Згідно з eIDAS, електронному підпису не можна відмовити в юридичній силі лише тому, що він електронний. Якщо закон вимагає письмової форми, використовуйте кваліфікований електронний підпис від кваліфікованого надавача довірчих послуг. Там, де це увімкнено, також доступні підписи Profil Zaufany (польський державний профіль eID) та e-dowód (польська електронна ID-картка) через Węzeł Podpisu (польський державний сервіс підписання)."
        },
        {
          "q": "Чи покаже Adobe Reader підписи?",
          "a": "Так. Підписи відповідають стандарту PAdES і відображаються на панелі підписів. Чи позначить Adobe особу підписанта як довірену, залежить від його власного списку довіри."
        },
        {
          "q": "Що станеться, якщо хтось змінить PDF після підписання?",
          "a": "Зміна виходить за межі підписаного діапазону байтів, тому програми для PDF і верифікатор sign.yt повідомлять, що документ змінено."
        },
        {
          "q": "Чи потрібен мені власний сертифікат?",
          "a": "Ні. sign.yt автоматично видає сертифікати для кожного підписанта. Кваліфіковані підписи доступні як окремий метод підписання."
        }
      ]
    },
    "trusted-timestamps": {
      "name": "Довірені позначки часу",
      "title": "Позначки часу RFC 3161 з резервними TSA",
      "desc": "Кожен підпис отримує позначку часу RFC 3161 від незалежної служби. Спершу Certum, а якщо вона недоступна, то DigiCert, Sectigo і FreeTSA.",
      "h1": "Час підписання, підтверджений незалежною службою",
      "lead": "Час на підписі sign.yt береться не лише з годинника нашого сервера. Його також підписує служба позначок часу, тож дата витримає будь-яку перевірку.",
      "sections": [
        {
          "h2": "Чотири служби, один підпис",
          "body": "sign.yt спершу запитує позначку часу в Certum. Якщо вона не відповідає, її заміняє наступна служба зі списку: DigiCert, потім Sectigo, потім FreeTSA. Один підпис від початку до кінця завжди використовує одну службу, а основна служба після відновлення знову використовується за кілька хвилин.\n\nЯкщо жодна служба недоступна, документ все одно підписується на рівні PAdES-B-B, замість того щоб чекати безкінечно."
        },
        {
          "h2": "Вбудована довгострокова перевірка",
          "body": "Із позначкою часу фінальна печатка доповнюється даними для перевірки та позначкою часу документа (PAdES-B-LTA). Кореневі сертифікати всіх чотирьох служб постачаються разом із платформою, тож шлях перевірки можна побудувати без додаткових налаштувань.\n\nЦе означає, що підпис можна буде перевірити й через багато років, коли сертифікати підписання вже втратять чинність."
        },
        {
          "h2": "Кваліфікація на сторінці перевірки",
          "body": "Коли ви завантажуєте підписаний PDF у верифікатор, кожна позначка часу перевіряється за довірчими списками ЄС. Сторінка показує, чи це позначка часу підпису, чи архівна, і чи походить вона від кваліфікованої служби позначок часу (QTSA), дата якої за законом вважається точною.",
          "requires": "eidas_validation"
        }
      ],
      "faq": [
        {
          "q": "Що таке позначка часу RFC 3161?",
          "a": "Невеликий токен, підписаний службою позначок часу, який доводить, що певний хеш існував у певний момент. Він вбудовується в підпис PDF."
        },
        {
          "q": "Що буде, якщо служба позначок часу недоступна?",
          "a": "sign.yt переходить до наступної у списку. Лише якщо всі вони недоступні, підпис створюється без позначки часу."
        },
        {
          "q": "Чи можна використовувати власну службу позначок часу?",
          "a": "Список служб задається для всієї платформи. Зв'яжіться з нами, якщо ваші договори вимагають конкретного кваліфікованого надавача."
        }
      ]
    },
    "bitcoin-anchoring": {
      "name": "Закріплення в Bitcoin",
      "title": "Хеші документів, закріплені в блокчейні Bitcoin",
      "desc": "Кожен завершений документ закріплюється в Bitcoin через OpenTimestamps. Будь-хто перевірить доказ інструментами з відкритим кодом, без довіри до sign.yt.",
      "h1": "Доказ, який не залежить від нас",
      "lead": "Коли документ завершено, його відбиток потрапляє в блок Bitcoin. Через роки будь-хто зможе довести, що файл існував у той момент, навіть якщо sign.yt уже не буде.",
      "sections": [
        {
          "h2": "Що саме закріплюється",
          "body": "sign.yt закріплює через OpenTimestamps хеші SHA-256 підписаного PDF, журналу аудиту та вершини ланцюга аудиту. Платформу залишають лише хеші, ніколи не сам документ чи персональні дані.\n\nЗазвичай доказ підтверджується в блоці Bitcoin протягом кількох годин."
        },
        {
          "h2": "Перевірте самостійно",
          "body": "ZIP-архів із доказами містить доказ .ots і список закріплених хешів. Перевірте їх відкритим клієнтом ots за будь-яким вузлом Bitcoin чи оглядачем блоків, без облікового запису і без звернення до нас.\n\nПублічна сторінка перевірки також показує статус закріплення та висоту блоку з посиланням на блок."
        },
        {
          "h2": "Навіщо блокчейн",
          "body": "Рядок у базі даних може змінити той, хто цією базою керує. Блок Bitcoin не може змінити ніхто. Тому закріплення є сильною, незалежною відповіддю на питання: «чи існував цей файл того дня саме в такому вигляді?»."
        }
      ],
      "faq": [
        {
          "q": "Чи sign.yt розміщує мій документ у блокчейні?",
          "a": "Ні. Закріплюються лише хеші. Хеш нічого не розкриває про вміст, але будь-яка зміна файлу дає інший хеш."
        },
        {
          "q": "Чи плачу я за транзакції Bitcoin?",
          "a": "Ні. Публічні календарі OpenTimestamps об'єднують багато хешів в одну транзакцію, тож плати за документ немає."
        },
        {
          "q": "Скільки часу потрібно, щоб доказ став остаточним?",
          "a": "Зазвичай кілька годин. До того закріплення показується як таке, що очікує; доказ оновлюється автоматично."
        }
      ]
    },
    "post-quantum-seal": {
      "name": "Постквантова печатка",
      "title": "Постквантова печатка: ML-DSA-65 + Ed25519",
      "desc": "Друга печатка на кожному завершеному документі, підписана ML-DSA-65 та Ed25519. Вона лишиться перевірюваною, навіть коли квантові комп'ютери зламають ключі.",
      "h1": "Докази, що переживуть квантову еру",
      "lead": "Сучасні підписи спираються на математику, яку великий квантовий комп'ютер може зламати. sign.yt додає гібридну постквантову печатку, тож ваші докази зберігають цінність десятиліттями.",
      "sections": [
        {
          "h2": "Два алгоритми, обидва мають витримати",
          "body": "Печатка підписує маніфест, що пов'язує хеш фінального PDF, вершину ланцюга аудиту та докази підписантів. Вона підписується двічі: алгоритмом ML-DSA-65 (FIPS 204, постквантовий) та Ed25519. Печатка дійсна, лише якщо обидва підписи проходять перевірку, тож вона тримається, доки хоча б один алгоритм не зламано.\n\nЦе додатковий доказ поряд із підписом PAdES, а не заміна кваліфікованого підпису."
        },
        {
          "h2": "Перевірка в офлайні",
          "body": "Файл печатки входить до ZIP-архіву з доказами. Завантажте його разом із PDF у публічний верифікатор або перевірте в офлайні за опублікованими відкритими ключами.\n\nОфлайновий кореневий ключ засвідчує або відкликає робочі ключі. Його приватна частина ніколи не потрапляє на сервер. Скомпрометований робочий ключ можна відкликати, а печатки з відкликаних чи незасвідчених ключів не проходять перевірку."
        },
        {
          "h2": "Ключі в AWS KMS",
          "body": "На цій платформі ключі печатки зберігаються в AWS Key Management Service. Підписання відбувається всередині HSM, і приватні ключі ніколи його не залишають; кожен підпис перевіряється локально перед збереженням.",
          "requires": "aws_kms"
        }
      ],
      "faq": [
        {
          "q": "Навіщо це потрібно вже сьогодні?",
          "a": "Договори зберігаються роками. Зловмисник може зберегти підписані файли зараз і спробувати їх підробити, коли квантові комп'ютери стануть достатньо потужними. Печатка закриває цю прогалину."
        },
        {
          "q": "Чи замінює вона підпис PAdES?",
          "a": "Ні. PAdES залишається стандартним підписом, який розуміють програми для PDF. Постквантова печатка є додатковим, незалежним шаром доказів."
        },
        {
          "q": "Що таке ML-DSA?",
          "a": "Алгоритм цифрового підпису, стандартизований NIST у FIPS 204 і розроблений для захисту від атак квантових комп'ютерів."
        }
      ]
    },
    "public-verification": {
      "name": "Публічна перевірка",
      "title": "Перевірка підписаного документа за QR-кодом",
      "desc": "Кожен підписаний документ має QR-код і коротке посилання на публічну сторінку перевірки: масковані імена, дати підписання, статус печатки та порівняння файлу.",
      "h1": "Будь-хто може перевірити документ за кілька секунд",
      "lead": "Контрагенту, банку чи суду не потрібен обліковий запис, щоб довіряти вашому документу. Достатньо відсканувати QR-код або завантажити PDF у верифікатор.",
      "sections": [
        {
          "h2": "QR-код на кожному сертифікаті",
          "body": "Сертифікат завершення кожного підписаного документа містить QR-код і коротке посилання, наприклад verify.sign.yt/k3Fq9ZxT2mPa7LwB. Воно відкриває публічну сторінку зі статусом документа, кількістю зібраних підписів і часом їх накладення, хешем підписаного оригіналу, печаткою платформи, постквантовою печаткою та закріпленням у Bitcoin.\n\nСторінка використовує брендинг організації, яка надіслала документ."
        },
        {
          "h2": "Перевірте, що ваш файл ідентичний",
          "body": "QR-код доводить, що документ існує в sign.yt. Щоб довести, що ваша копія не змінена, завантажте її на тій самій сторінці: її хеш порівнюється з хешем підписаного оригіналу, а поруч показується повний звіт про підписи."
        },
        {
          "h2": "Жодних персональних даних у відкритому доступі",
          "body": "Імена підписантів масковано, наприклад «J. K*****», і не показуються жодні email, номери телефонів чи IP-адреси. Посилання є довгим випадковим кодом, який неможливо вгадати, а кількість запитів обмежена.\n\nБудь-який PDF, підписаний у sign.yt чи ні, також можна завантажити у верифікатор, щоб побачити, чи його підписи цілі."
        }
      ],
      "faq": [
        {
          "q": "Чи потрібен обліковий запис тому, хто перевіряє?",
          "a": "Ні. І сторінка за QR-кодом, і верифікатор PDF є публічними."
        },
        {
          "q": "Що розкриває публічна сторінка?",
          "a": "Статус, масковані імена підписантів із датами підписання, фінальний хеш, а також статус печатки та закріплення. Але не вміст документа."
        },
        {
          "q": "Чи можуть посилання використовувати мій домен?",
          "a": "За замовчуванням вони ведуть на verify.sign.yt. Перенесення їх на ваш домен входить до платного доповнення Full customization."
        }
      ]
    },
    "sms-email-verification": {
      "name": "Перевірка через SMS та email",
      "title": "Перевірка підписантів кодом із SMS та email",
      "desc": "Підтвердіть, хто підписує, одноразовим кодом з email, SMS або обома способами. Коди діють 10 хвилин, а кожна перевірка потрапляє до журналу аудиту.",
      "h1": "Знайте, хто підписав, а не лише яке посилання відкрили",
      "lead": "Додайте крок з одноразовим кодом перед підписанням. Одержувач доводить доступ до своєї пошти, телефону або обох, а результат фіксується як доказ.",
      "sections": [
        {
          "h2": "Рівень перевірки для кожного документа",
          "body": "Для кожного документа ви вирішуєте, наскільки суворою має бути перевірка: без неї для простого ознайомлення, код з email для щоденних договорів, код з SMS для вагоміших угод або обидва. В останньому випадку одержувач підтверджує код з email під час відкриття документа, а код з SMS безпосередньо перед підписанням.\n\nОдержувачу ніколи не потрібні обліковий запис чи застосунок. Код надходить туди, де людина вже є, а сторінка підписання проводить її через цей крок."
        },
        {
          "h2": "Шість цифр, короткий строк дії, важко вгадати",
          "body": "Коди складаються з шести випадкових цифр і діють 10 хвилин. Після п'яти помилкових спроб код анулюється, новий можна запросити через 60 секунд, а кількість спроб перевірки для одного посилання обмежена на день.\n\nДля SMS також діє погодинний ліміт на номер, що захищає ваш обліковий запис від SMS pumping.\n\nЦі обмеження діють автоматично, нічого налаштовувати не потрібно."
        },
        {
          "h2": "SMS через BulkGate",
          "body": "Текстові повідомлення надсилаються через BulkGate, європейський SMS-шлюз. Ви можете задати власне ім'я відправника довжиною до 11 символів, тож код приходить від вашого бренду, а не з випадкового номера.\n\nНомери телефонів зберігаються в міжнародному форматі E.164. Якщо повідомлення затримується, одержувач може запросити новий код на сторінці підписання після короткої паузи, не звертаючись до вас."
        },
        {
          "h2": "Доказ у сертифікаті завершення",
          "body": "Метод перевірки та точний час підтвердження кожного коду вказуються в сертифікаті завершення, доданому до підписаного PDF, і в журналі аудиту. Якщо підпис колись оскаржать, ви зможете показати, який канал контролював підписант.\n\nПідписантів, які використали код, чітко відрізнено від тих, хто підписав без нього."
        }
      ],
      "faq": [
        {
          "q": "Скільки діє код?",
          "a": "10 хвилин. Після цього одержувач запитує новий на сторінці підписання."
        },
        {
          "q": "Чи потрібен одержувачу обліковий запис?",
          "a": "Ні. Одержувачі підписують за посиланням із листа; код є єдиним додатковим кроком."
        },
        {
          "q": "Чи можна вимагати і email, і SMS?",
          "a": "Так. Код з email перевіряється під час відкриття документа, а код з SMS безпосередньо перед підписанням."
        },
        {
          "q": "Чи є сильніша перевірка, ніж коди?",
          "a": "Так. Перевірка особи через login.gov.pl, Profil Zaufany (польський державний профіль eID) або кваліфіковані підписи доступна, якщо її увімкнено для вашої організації."
        }
      ]
    },
    "mobile-signing": {
      "name": "Підписання на телефоні",
      "title": "Підписання документів онлайн на телефоні",
      "desc": "Одержувачі підписують на телефоні в нижній панелі із закріпленою кнопкою дії. Запрошення надходять від конкретної людини з вашою темою та повідомленням.",
      "h1": "Більшість підписантів відкривають посилання на телефоні",
      "lead": "Тому сторінка підписання створена для одного пальця. А лист, що веде на неї, надходить від реальної людини, а не від робота no-reply.",
      "sections": [
        {
          "h2": "Підписання, створене для малих екранів",
          "body": "На телефоні PDF прокручується разом зі сторінкою, рендериться чітко для екрана і підлаштовується, коли телефон повертають. Торкніться поля або закріпленої панелі внизу, і елементи підписання відкриються в нижній панелі: намалюйте чи введіть підпис, заповніть поле, рухайтеся далі.\n\nПанель завжди показує, що залишилося зробити, і зникає, коли строк дії документа минув або його скасовано."
        },
        {
          "h2": "Запрошення від людини",
          "body": "Запрошення показує відправника на ім'я, наприклад «Anna Nowak via sign.yt» або від назви вашого бренду, а відповіді надходять безпосередньо Анні, а не на скриньку no-reply. Стандартна тема повідомляє, хто просить підпис і для якого документа.\n\nПеред надсиланням можна змінити тему та додати особисте повідомлення. Це працює і з керованим відправником, і з кожним поштовим провайдером, який ви підключите."
        },
        {
          "h2": "Менше запитань «це не фішинг?»",
          "body": "Знайоме ім'я, ваш бренд і повідомлення, написане саме для цього одержувача, роблять лист гідним довіри. Якщо в одержувача є запитання, він просто натискає «Відповісти»."
        }
      ],
      "faq": [
        {
          "q": "Чи потрібен підписанту застосунок?",
          "a": "Ні. Підписання працює в браузері телефону за посиланням із листа."
        },
        {
          "q": "Куди надходять відповіді на запрошення?",
          "a": "Людині, яка надіслала документ. Заголовок Reply-To вказує на відправника."
        },
        {
          "q": "Чи можна написати власний текст листа?",
          "a": "Так. Змініть тему та додайте особисте повідомлення у вікні надсилання."
        }
      ]
    },
    "profil-zaufany-wezel-podpisu": {
      "name": "Profil Zaufany та кваліфіковані підписи",
      "title": "Profil Zaufany, e-dowód і кваліфікований підпис",
      "desc": "Підписанти в Польщі можуть використати Profil Zaufany, e-dowód чи mObywatel через Węzeł Podpisu або кваліфікований електронний підпис від надавача послуг.",
      "h1": "Державний рівень ідентифікації для документів, яким він потрібен",
      "lead": "Деякі договори потребують більшого, ніж код. sign.yt підключається до Węzeł Podpisu (польського державного сервісу підписання) та до кваліфікованих надавачів довірчих послуг, тож підписанти можуть використовувати інструменти ідентифікації, які вже мають.",
      "sections": [
        {
          "h2": "Węzeł Podpisu в процесі підписання",
          "body": "Для кожного одержувача можна обрати метод Węzeł Podpisu: Profil Zaufany (польський державний профіль eID), e-dowód (польська електронна ID-картка), особистий підпис (podpis osobisty), mObywatel (польський державний мобільний застосунок ID) або кваліфікований підпис. Одержувача перенаправляють до державного сервісу, він підписує там, а sign.yt зберігає підписаний PDF і передає документ наступному підписанту.\n\nПаралельний і послідовний порядок підписання працюють так само, як і зі звичайними підписами."
        },
        {
          "h2": "Кваліфіковані електронні підписи",
          "body": "Кваліфікований підпис (QES) є рівнем eIDAS, рівнозначним власноручному підпису. sign.yt підтримує два шляхи: віддалене підписання в кваліфікованого надавача через Cloud Signature Consortium API або завантаження, коли підписант підписує PDF будь-яким інструментом QES і завантажує його назад.\n\nВіддалене підписання працює з надавачами, які мають endpoint CSC v2. Шлях із завантаженням працює зі смарт-картками, хмарними сертифікатами та іншими кваліфікованими інструментами, тож підписант не прив'язаний до одного постачальника."
        },
        {
          "h2": "Попередні підписи залишаються цілими",
          "body": "Кваліфіковані підписи додаються інкрементально до останньої редакції документа. Завантажені файли приймаються, лише якщо вони доповнюють саме ті байти, які надіслав sign.yt, а сертифікат підписання має бути внесений як кваліфікований до довірчого списку ЄС.\n\nЦе означає, що на одному документі можна поєднувати методи: одна сторона підписує через Profil Zaufany, інша кваліфікованим сертифікатом, а третя звичайним підписом sign.yt, і журнал аудиту фіксує кожен крок."
        }
      ],
      "faq": [
        {
          "q": "Чи потрібен мені кваліфікований підпис?",
          "a": "Лише там, де закон вимагає письмової форми або цього просить ваш контрагент. Для більшості комерційних угод достатньо звичайного електронного підпису з перевіркою. У конкретних випадках проконсультуйтеся з юристом."
        },
        {
          "q": "Чи платить щось підписант?",
          "a": "Profil Zaufany, e-dowód і mObywatel є власними державними інструментами підписанта. Кваліфіковані сертифікати видають надавачі довірчих послуг на власних умовах."
        },
        {
          "q": "Чи доступно це в кожному обліковому записі?",
          "a": "Węzeł Podpisu та підключення кваліфікованих надавачів вмикаються для кожної організації окремо. Напишіть на sales@sign.yt, щоб їх налаштувати."
        },
        {
          "q": "Які кваліфіковані інструменти працюють зі шляхом завантаження?",
          "a": "Будь-який інструмент, що створює кваліфікований підпис PAdES, визнаний у довірчому списку ЄС, наприклад смарт-картка або хмарний сертифікат."
        }
      ]
    },
    "email-delivery-providers": {
      "name": "Доставка листів",
      "title": "Листи на підпис із вашого власного домену",
      "desc": "Надсилайте запрошення на підпис через власний SMTP, Microsoft 365 (Graph API), Resend, Amazon SES чи Mailgun, з перевіркою SPF, DKIM і DMARC.",
      "h1": "Листи на підпис з вашої адреси, через вашого провайдера",
      "lead": "Запрошення з вашого власного домену відкривають. Підключіть поштовий сервіс, яким ви вже користуєтеся, і sign.yt надсилатиме через нього кожне сповіщення.",
      "sections": [
        {
          "h2": "Оберіть провайдера, якому вже довіряєте",
          "body": "Почніть із керованої доставки, без жодних налаштувань. Коли будете готові, переведіть організацію на власний SMTP-сервер, Microsoft 365 через Graph API, власний обліковий запис Resend, Amazon SES або Mailgun.\n\nОблікові дані провайдера зберігаються зашифрованими, ніколи у відкритому вигляді.\n\nКожна організація обирає одного провайдера, тож кожне запрошення, нагадування та лист про завершення надсилаються однаково."
        },
        {
          "h2": "Microsoft 365 без паролів SMTP",
          "body": "Через Graph API sign.yt надсилає листи від імені поштової скриньки у вашому тенанті Microsoft 365, використовуючи реєстрацію застосунку Azure з дозволом Mail.Send. Жодного пароля SMTP для зберігання і жодної базової автентифікації, яку треба тримати увімкненою у вашому тенанті.\n\nВи обираєте адресу відправника, наприклад contracts@vashafirma.com, тож відповіді одержувачів потрапляють до реальної скриньки, яку ваша команда вже переглядає."
        },
        {
          "h2": "Записи DNS перевіряємо за вас",
          "body": "Екран налаштувань показує записи SPF, DKIM і DMARC, потрібні домену відправника для обраного провайдера, перевіряє їх у реальному часі та показує, які вже на місці. Менше запрошень потрапляє в спам.\n\nЗаписи DKIM для Amazon SES отримуються для вашого домену автоматично, а для інших провайдерів екран точно вказує, які значення скопіювати в панель DNS."
        },
        {
          "h2": "Відмови доставки не залишаються непоміченими",
          "body": "За керованої доставки листи, що повернулися або позначені як спам, позначають одержувача як недоступного, записуються до журналу аудиту та запускають вебхук recipient.bounced, тож ви можете виправити адресу, а не чекати підпису, який ніколи не надійде.\n\nТа сама інформація про відмову доставки видна в документі поруч з одержувачем. Ви дізнаєтеся про неї, щойно провайдер повідомить, а не після того, як мине строк підписання."
        }
      ],
      "faq": [
        {
          "q": "Які поштові провайдери підтримуються?",
          "a": "Керована доставка, SMTP, Microsoft 365 через Graph API, Resend із власним обліковим записом, Amazon SES і Mailgun."
        },
        {
          "q": "Які порти SMTP можна використовувати?",
          "a": "Порти 25, 465, 587 і 2525, із TLS."
        },
        {
          "q": "Чи можуть команди мати різні імена відправника?",
          "a": "Так. Ім'я відправника можна задати для кожної команди через брендинг команди."
        },
        {
          "q": "Чи потрібно щось налаштовувати для початку?",
          "a": "Ні. Керована доставка працює одразу; власний провайдер необов'язковий."
        }
      ]
    },
    "document-templates": {
      "name": "Шаблони документів",
      "title": "Шаблони документів і публічні посилання",
      "desc": "Зберігайте договори як шаблони з підписантами та полями. Використовуйте їх повторно за секунди, замінюйте PDF або діліться публічним посиланням на підпис.",
      "h1": "Налаштуйте договір один раз і надсилайте сто разів",
      "lead": "Шаблони зберігають PDF, ролі підписантів і розташування полів разом. Повторне надсилання тієї самої угоди займає кілька кліків замість нового налаштування.",
      "sections": [
        {
          "h2": "Шаблон із будь-якого документа",
          "body": "Завантажте PDF і розмістіть поля підпису, дати, тексту та прапорці або перетворіть на шаблон документ, який ви вже надсилали. Ролі підписантів і розташування полів зберігаються разом із ним.\n\nКоли текст договору змінюється, а макет лишається тим самим, замініть PDF, і кожне поле залишиться на своєму місці.\n\nШаблони впорядковано за категоріями, тож ваша команда швидко знаходить потрібну угоду."
        },
        {
          "h2": "Публічні посилання та QR-коди",
          "body": "Увімкніть публічне посилання для шаблону, і будь-хто з цим посиланням зможе заповнити та підписати його, наприклад анкету для онбордингу чи маркетингову згоду. sign.yt також генерує QR-код для посилання, готовий для листівки чи стійки рецепції.\n\nПублічне посилання можна вимкнути будь-коли й обмежити датою завершення або кількістю використань. Кожна підписана копія є окремим документом із власним журналом аудиту."
        },
        {
          "h2": "Швидкий старт для польського малого бізнесу",
          "body": "Стартовий каталог пропонує ролі, порядок підписання, рівень перевірки та розташування полів для типових документів віртуальних офісів, юридичних фірм, бухгалтерії, HR і GDPR. Ви завантажуєте власний PDF, а шаблон-заготовка заповнює решту.\n\nЦе швидший старт, ніж порожній редактор, особливо для команд, які готують свої перші шаблони. Категорії відображають галузі, з якими ми працюємо найчастіше."
        },
        {
          "h2": "Поля розміщуються за вас",
          "body": "На ваш запит sign.yt може проаналізувати сторінку PDF і запропонувати, де мають бути поля підпису, дати та тексту. Ви переглядаєте пропозицію, коригуєте її та зберігаєте.\n\nРозпізнавання необов'язкове і запускається лише тоді, коли ви про це просите. Остаточний макет завжди вирішуєте ви, і будь-яке запропоноване поле можна перемістити, змінити його розмір або видалити, перш ніж документ піде одержувачам."
        }
      ],
      "faq": [
        {
          "q": "Чи можна оновити шаблон, не налаштовуючи поля наново?",
          "a": "Так. Замініть PDF, і наявне розташування полів збережеться."
        },
        {
          "q": "Хто може підписати через публічне посилання?",
          "a": "Будь-хто, у кого є посилання, доки воно увімкнене. Ви можете вимкнути його будь-коли."
        },
        {
          "q": "Чи автоматичне розпізнавання полів увімкнене завжди?",
          "a": "Ні. Воно запускається лише тоді, коли ви натискаєте кнопку в редакторі полів."
        }
      ]
    },
    "bulk-send-campaigns": {
      "name": "Масове надсилання та кампанії",
      "title": "Масове надсилання документів на підпис із CSV",
      "desc": "Надішліть один документ сотням людей із файлу CSV. Контрольований темп, пауза й відновлення, нагадування, експорт у CSV і публічні кампанії з QR-кодом.",
      "h1": "Один документ, сотні підписантів, нуль копіювання",
      "lead": "Щорічні оновлення політик, нові умови обслуговування, оновлення згод. Кампанії надсилають кожній людині її власний документ і відстежують кожен підпис в одному місці.",
      "sections": [
        {
          "h2": "Завантажте CSV, перевірте, надішліть",
          "body": "Підготуйте CSV з email, іменем і телефоном, і sign.yt покаже попередній перегляд, перш ніж щось буде надіслано. Кожен одержувач отримує окремий документ, тож підпис чи відмова однієї людини ніколи не блокує інших.\n\nТипові сценарії: щорічне оновлення NDA, оновлені умови для всіх клієнтів або нова згода для кожного орендаря. Попередній перегляд позначає проблеми у файлі, наприклад відсутній стовпець email, ще до надсилання."
        },
        {
          "h2": "Надсилання в безпечному темпі",
          "body": "Кампанії надсилаються у фоновому режимі з лімітом для організації, спільним із нагадуваннями, тож великий список не переповнить вашу скриньку і не перевищить ліміти провайдера. Запущену кампанію можна будь-коли призупинити, відновити або скасувати.\n\nНадсилання обробляється рядок за рядком, тож навіть за кількох паралельних воркерів ніхто не отримає той самий документ двічі."
        },
        {
          "h2": "Контроль без таблиць",
          "body": "Вікно кампанії показує, хто вже підписав, а хто ні. Надішліть нагадування всім, хто ще не підписав, повторіть невдалі надсилання та експортуйте результати в CSV або докази в JSON для своїх записів.\n\nДля публічних кампаній також можна додати список людей, від яких ви очікуєте підпис, і одразу бачити, кого ще бракує."
        },
        {
          "h2": "Публічні кампанії з QR-кодом",
          "body": "Потрібні підписи людей, яких ще немає у вашому списку, наприклад учасників заходу чи нових орендарів? Публічна кампанія дає вам посилання та QR-код, і кожен відвідувач підписує власну копію.\n\nКожна копія має власні підписи, перевірку та журнал аудиту, так само як документ, надісланий зі списку."
        }
      ],
      "faq": [
        {
          "q": "Які стовпці потрібні в CSV?",
          "a": "Email, ім'я та за бажанням телефон, який використовується для перевірки через SMS."
        },
        {
          "q": "Чи можна зупинити кампанію на півдорозі?",
          "a": "Так. Призупиніть і відновіть її або скасуйте решту надсилань."
        },
        {
          "q": "Чи враховуються нагадування в ліміті надсилання?",
          "a": "Так. Кампанії та нагадування мають один спільний ліміт для організації, що забезпечує рівномірну доставку."
        }
      ]
    },
    "smart-documents-gus-vies": {
      "name": "Розумні документи",
      "title": "Генератор договорів з автозаповненням GUS і VIES",
      "desc": "Створюйте договори із шаблонів зі змінними. Введіть NIP, і дані компанії заповняться з GUS, білого списку ПДВ MF та VIES, після чого надішліть на підпис.",
      "h1": "Договори, що заповнюються самі за податковим номером",
      "lead": "Розумні документи перетворюють текст вашого договору на форму. Введіть NIP, отримайте дані компанії з публічних реєстрів і згенеруйте PDF, готові до підписання.",
      "sections": [
        {
          "h2": "Дані компанії з публічних реєстрів",
          "body": "Введіть польський NIP, і sign.yt поєднає дані з GUS (REGON, KRS, організаційно-правова форма, адреса) з білим списком платників ПДВ Міністерства фінансів (статус ПДВ і банківські рахунки). Для інших країн ЄС використовується VIES.\n\nЯкщо одне джерело недоступне, інші все одно заповнять те, що можуть, і ви побачите попередження замість помилки."
        },
        {
          "h2": "Шаблони зі справжньою логікою",
          "body": "Напишіть договір у вбудованому редакторі або імпортуйте файл .docx, у якому заповнювачі у квадратних дужках чи подвійних фігурних дужках стають змінними. Змінні мають типи, наприклад сума, дата, NIP, IBAN або список, і можна додавати умовні розділи, повторювані рядки та обчислювані значення.\n\nОбчислювані значення використовують безпечну мову виразів, тож підсумки, суми нетто й брутто чи строки оплати розраховуються за вас. Готовий документ рендериться в PDF і проходить звичайний процес підписання."
        },
        {
          "h2": "Польське форматування вбудоване",
          "body": "Суми форматуються по-польськи і можуть бути записані словами, дати відповідають польським стандартам, а платежі можна автоматично розбити на частини. Більше жодних ручних полів «słownie».\n\nЗначення перевіряються на відповідність типу перед генерацією, тож неправильний NIP чи IBAN буде виявлено у формі, а не в підписаному договорі. Кожен згенерований PDF виглядає як документ, підготовлений вручну вашим офісом."
        },
        {
          "h2": "Одна форма, цілий пакет",
          "body": "Об'єднайте кілька документів у пакет, наприклад договір, додаток і застереження щодо GDPR. Спільні змінні заповнюються один раз, і sign.yt генерує та надсилає всі документи разом.\n\nФорма пакета показує кожну змінну лише один раз, навіть якщо вона трапляється в кількох документах. Це усуває помилки копіювання між основним договором і додатками, а одержувач підписує весь комплект за один раз."
        }
      ],
      "faq": [
        {
          "q": "Які реєстри використовуються?",
          "a": "GUS BIR (база REGON), білий список платників ПДВ Міністерства фінансів і система ЄС VIES."
        },
        {
          "q": "Чи можуть підписанти самі заповнити дані своєї компанії?",
          "a": "Так. На сторінці підписання одержувач може ввести свій NIP і отримати дані своєї компанії з реєстрів."
        },
        {
          "q": "Чи можна імпортувати наявні договори Word?",
          "a": "Так. Завантажте файл .docx, і заповнювачі на кшталт [CLIENT NAME] або {{client.name}} стануть змінними."
        }
      ]
    },
    "api-webhooks": {
      "name": "API та вебхуки",
      "title": "REST API і підписані вебхуки",
      "desc": "Створюйте, надсилайте та відстежуйте документи з власного ПЗ. API-ключі з обмеженими правами, вебхуки з HMAC-підписом і повторами, версіонований REST API.",
      "h1": "Електронний підпис усередині програм, якими ви вже користуєтеся",
      "lead": "Ваша CRM, ERP чи клієнтський портал можуть створювати документи, надсилати їх на підпис і реагувати в момент підписання, без того щоб хтось відкривав sign.yt.",
      "sections": [
        {
          "h2": "Версіонований REST API",
          "body": "Усе розміщено під api.sign.yt/v1 і працює з JSON: документи, одержувачі, поля, шаблони та вебхуки. Створіть документ із шаблону, надішліть його та завантажте підписаний PDF за кілька запитів.\n\nКожен запит обмежений організацією, якій належить API-ключ, тож одна інтеграція ніколи не побачить документи іншого клієнта. Помилки повертаються як структурований JSON зі зрозумілими кодами статусу, що спрощує клієнтський код."
        },
        {
          "h2": "API-ключі з областями доступу",
          "body": "Кожна організація створює власні API-ключі та надає кожному ключу лише потрібні області доступу, читання або запис для кожного розділу. Ключі зберігаються у вигляді хешів, після створення показується лише префікс, а кожен ключ обмежено 100 запитами на секунду.\n\nВідкличте ключ будь-коли, і інтеграції, що його використовують, одразу зупиняться. Час останнього використання допомагає знайти ключі, які вже нікому не потрібні."
        },
        {
          "h2": "Вебхуки, яким можна довіряти",
          "body": "Підпишіться на події, як-от document.sent, document.viewed, document.signed, document.completed, document.rejected, document.expired і recipient.bounced. Кожна доставка підписується HMAC-SHA256 від позначки часу та необробленого тіла, тож ви можете перевірити, що вона надійшла від sign.yt, і відхилити повторні запити.\n\nEndpoint повторно перевіряється перед кожною доставкою, щоб заблокувати запити на внутрішні адреси. Кожен запит також містить у заголовках назву події та ID доставки, тож події легко маршрутизувати та дедуплікувати."
        },
        {
          "h2": "Вбудовані повтори",
          "body": "Якщо ваш endpoint недоступний, sign.yt повторює спробу через 1 хвилину, 5 хвилин, 30 хвилин, 2 години та 12 годин. Кожна доставка має стабільний ID для дедуплікації, а невдалі доставки зберігаються, тож ніщо не губиться непомітно.\n\nКожна спроба підписується заново зі свіжою позначкою часу, тож навіть повтор через кілька годин проходить перевірку вікна повторів на вашому боці."
        }
      ],
      "faq": [
        {
          "q": "Як пройти автентифікацію?",
          "a": "Надсилайте свій API-ключ як Bearer-токен у заголовку Authorization."
        },
        {
          "q": "Як перевірити вебхук?",
          "a": "Обчисліть HMAC-SHA256 від заголовка позначки часу, крапки та необробленого тіла за допомогою секрету вебхука і порівняйте результат із заголовком X-Signyt-Signature."
        },
        {
          "q": "Що буде, якщо мій endpoint не відповідає?",
          "a": "sign.yt повторює спробу п'ять разів упродовж приблизно 15 годин, після чого позначає доставку як невдалу."
        },
        {
          "q": "Які тарифи включають доступ до API?",
          "a": "API-ключі та вебхуки входять до тарифу Business і вищих."
        }
      ]
    },
    "audit-trail": {
      "name": "Журнал аудиту",
      "title": "Захищений журнал аудиту для електронного підпису",
      "desc": "Кожна дія записується в журнал аудиту лише з додаванням і хеш-ланцюгом. Підписи пов'язані в ланцюг, а до кожного PDF додається сертифікат завершення.",
      "h1": "Журнал аудиту, який покаже, чи хтось намагався переписати історію",
      "lead": "Хто надіслав, хто відкрив, хто пройшов перевірку і хто підписав, з IP-адресами та позначками часу. Записи пов'язані ланцюгом SHA-256, тож видалений чи змінений запис розриває ланцюг.",
      "sections": [
        {
          "h2": "Журнал лише з додаванням і хеш-ланцюгом",
          "body": "Кожен запис аудиту зберігає хеш попереднього запису в ланцюгу вашої організації. Записи лише додаються і ніколи не змінюються та не видаляються, що забезпечує сама база даних, а кожен клієнт має власний незалежний ланцюг.\n\nЯкби хтось видалив чи змінив запис безпосередньо в базі даних, ланцюг перестав би проходити перевірку. Події охоплюють увесь життєвий цикл, від входу та зміни налаштувань до надсилання, перегляду та підписання."
        },
        {
          "h2": "Підписи, пов'язані між собою",
          "body": "Кожен підпис на документі вказує на хеш попереднього. Перш ніж позначити документ як завершений, sign.yt перевіряє весь ланцюг і відмовляється завершувати документ, якщо щось не збігається.\n\nРозірваний ланцюг фіксується в журналі аудиту, тож проблему видно, а не тихо запечатано в готовому PDF. Разом із підписами PAdES це дає два незалежні способи довести послідовність подій."
        },
        {
          "h2": "Явна згода та закріплення в Bitcoin",
          "body": "Перед підписанням кожен підписант позначає текст згоди. Його текст, мова та хеш зберігаються разом із підписом і в журналі аудиту, тож ви можете показати, на що саме погодилася людина.\n\nКоли документ завершено, sign.yt закріплює хеші підписаного PDF, журналу аудиту та вершини ланцюга аудиту в Bitcoin через OpenTimestamps. Доказ показує, що файли існували на момент створення блоку, і його можна перевірити відкритим інструментом ots, не покладаючись на sign.yt."
        },
        {
          "h2": "Сертифікат завершення в PDF",
          "body": "Підписаний PDF завершується сертифікатом завершення: ім'я, email і роль кожного підписанта, метод перевірки, час надсилання, перегляду та підписання документа, IP-адреса та браузер. Ваші докази подорожують разом із файлом.\n\nОскільки сертифікат є частиною PDF, він залишається з кожною копією документа, де б її не зберігали чи кому б не пересилали. Його QR-код і коротке посилання відкривають публічну сторінку перевірки документа."
        },
        {
          "h2": "Знайдіть і експортуйте потрібне",
          "body": "Фільтруйте журнал аудиту організації за типом події або завантажте повну історію окремого документа в CSV для свого юриста чи аудитора.\n\nZIP-архів із доказами містить усе в одному завантаженні: підписаний PDF, окремий журнал аудиту, доказ OpenTimestamps, сертифікат печатки платформи, маніфест хешів SHA-256 і README з поясненням, як перевірити кожну частину. Підписанти також можуть його завантажити.\n\nЗаписи фіксують виконавця, email і IP-адресу, об'єкт і деталі події. Адміністратори організації бачать лише власну організацію, а журнал розбито на сторінки, тож навіть довгу історію швидко переглядати й шукати."
        }
      ],
      "faq": [
        {
          "q": "Чи можна змінити або видалити запис аудиту?",
          "a": "Ні. Журнал працює лише на додавання, а будь-яка зміна поза застосунком розриває хеш-ланцюг."
        },
        {
          "q": "Що містить сертифікат завершення?",
          "a": "Особу підписанта, метод перевірки, час надсилання, перегляду та підписання, IP-адресу та user agent."
        },
        {
          "q": "Чи можна експортувати журнал аудиту?",
          "a": "Так. Історію кожного документа можна завантажити в CSV, а повний пакет доказів як ZIP."
        },
        {
          "q": "Що таке закріплення в Bitcoin?",
          "a": "Доказ OpenTimestamps того, що хеші документа існували на момент видобутку певного блоку Bitcoin. Він підтверджується протягом кількох годин і може бути перевірений незалежно від sign.yt."
        }
      ]
    },
    "gdpr-rodo-compliance": {
      "name": "Відповідність GDPR",
      "title": "Електронний підпис за GDPR із шифруванням",
      "desc": "Запити на експорт і видалення даних обробляються в продукті, PDF шифруються окремим ключем для кожної організації, а дані клієнтів суворо ізольовані.",
      "h1": "Конфіденційність у продукті, а не в таблиці",
      "lead": "Запити суб'єктів даних, шифрування та ізоляція клієнтів є частиною sign.yt. Ви витрачаєте менше часу на документацію щодо GDPR і зберігаєте підписані документи, яких вимагає закон.",
      "sections": [
        {
          "h2": "Експорт на запит",
          "body": "Користувачі можуть завантажити всі свої дані у файлі ZIP: профіль, організації, метадані документів і підписів, контакти та записи аудиту, що їх стосуються. Люди без облікового запису, наприклад одержувачі, можуть запросити свої дані електронною поштою та отримати одноразове посилання для завантаження.\n\nКількість публічних запитів обмежена для кожного email та IP-адреси, тож ніхто не зможе перевантажити систему."
        },
        {
          "h2": "Видалення, що зберігає докази",
          "body": "Коли користувач просить його забути, sign.yt анонімізує його дані: імена та адреси email замінюються непрозорими мітками, сесії відкликаються, а методи входу видаляються. Підписані документи зберігаються, бо їх видалення зруйнувало б журнал аудиту та права інших сторін.\n\nОблікові записи суперадміністраторів вимагають додаткового підтвердження, що захищає від випадкового видалення."
        },
        {
          "h2": "Шифрування на диску для кожної організації",
          "body": "Завантажені та підписані PDF шифруються AES-256-GCM ключем, отриманим окремо для кожної організації. Облікові дані поштових і SMS-провайдерів зберігаються з шифруванням на рівні полів, ніколи у відкритому вигляді.\n\nКожен файл прив'язаний до своєї організації та документа, тож блоб, скопійований не туди, там неможливо розшифрувати. Ключі ніколи не зберігаються в базі даних поруч із даними, які вони захищають."
        },
        {
          "h2": "Клієнти ніколи не змішуються",
          "body": "Кожен запит обмежено організацією, до якої він належить. Запити на власному домені визначають рівно одну організацію, а ланцюги аудиту ведуться окремо для кожного клієнта.\n\nСаме ця ізоляція дає змогу багатьом компаніям і багатьом брендам ділити одну платформу, не ділячись даними. Договори ваших клієнтів бачать лише люди, яких ви запросили до своєї організації."
        }
      ],
      "faq": [
        {
          "q": "Чи можуть одержувачі без облікового запису скористатися своїми правами?",
          "a": "Так. Вони надсилають запит зі своєю адресою email і отримують посилання листом. Відповідь ніколи не розкриває, чи існує така адреса в системі."
        },
        {
          "q": "Чи видаляються підписані документи під час видалення даних?",
          "a": "Ні. Персональні дані анонімізуються, але підписані документи зберігаються, щоб зберегти докази та права інших сторін."
        },
        {
          "q": "Чи зашифровані мої дані?",
          "a": "Так. Документи шифруються на диску за допомогою AES-256-GCM з окремим ключем для кожної організації."
        }
      ]
    }
  },
  "groups": {
    "trust": "Довіра та право",
    "brand": "Ваш бренд",
    "docs": "Робота з документами",
    "dev": "Для розробників"
  },
  "plans": {
    "starter": [
      "50 документів / міс.",
      "3 користувачі, 1 команда",
      "Перевірка кодом з email",
      "«Powered by sign.yt» на сторінках входу"
    ],
    "professional": [
      "500 документів / міс.",
      "10 користувачів, 5 команд",
      "50 SMS-кодів / міс.",
      "Власний домен, без водяного знака"
    ],
    "business": [
      "Необмежена кількість документів, користувачів і команд",
      "SSO",
      "Власний поштовий провайдер",
      "REST API та вебхуки"
    ],
    "enterprise": [
      "Усе з тарифу Business",
      "SAML",
      "SLA та окрема підтримка",
      "Варіант on-premise"
    ]
  },
  "pricingFaq": [
    {
      "q": "Ціни вказано нетто чи брутто?",
      "a": "Усі ціни є місячними цінами нетто в PLN. Польський ПДВ (23%) додається у фактурі."
    },
    {
      "q": "Що буде, якщо ми перевищимо ліміт документів?",
      "a": "Платні тарифи продовжують працювати. Документи понад місячний ліміт оплачуються по 2 PLN за кожен у наступній фактурі, а адміністратори отримують сповіщення email на 80% і 100% ліміту."
    },
    {
      "q": "Чи виставляєте ви фактури з ПДВ?",
      "a": "Так. До кожного платежу додається фактура з ПДВ для вашої компанії з податковим номером і адресою для рахунків із налаштувань організації."
    },
    {
      "q": "Чи можна змінити тариф пізніше?",
      "a": "Так. Ви можете змінити тариф будь-коли в білінговому порталі, доступному з налаштувань оплати. Ліміти відповідатимуть новому тарифу."
    },
    {
      "q": "Чи можна додати більше команд без переходу на більший тариф?",
      "a": "Додаткові команди можна додати до платного тарифу за щомісячну плату. Напишіть нам, і ми налаштуємо це для вашої організації."
    },
    {
      "q": "Як формується ціна Enterprise?",
      "a": "Ціна Enterprise розраховується під ваші обсяги, вимоги безпеки та хостингу, зокрема SAML, SLA і варіант on-premise. Напишіть на sales@sign.yt."
    }
  ],
  "pricingRows": [
    [
      "Документів на місяць",
      [
        "50",
        "500",
        "Без обмежень",
        "Без обмежень"
      ]
    ],
    [
      "Користувачі",
      [
        "3",
        "10",
        "Без обмежень",
        "Без обмежень"
      ]
    ],
    [
      "Команди",
      [
        "1",
        "5",
        "Без обмежень",
        "Без обмежень"
      ]
    ],
    [
      "Перевірка кодом з email",
      [
        true,
        true,
        true,
        true
      ]
    ],
    [
      "SMS-коди",
      [
        false,
        "50 / міс.",
        true,
        true
      ]
    ],
    [
      "Власний домен для підписання",
      [
        false,
        true,
        true,
        true
      ]
    ],
    [
      "Ваш брендинг, без «Powered by»",
      [
        false,
        true,
        true,
        true
      ]
    ],
    [
      "SSO (Google, Microsoft, OIDC)",
      [
        false,
        false,
        true,
        true
      ]
    ],
    [
      "Власний поштовий провайдер",
      [
        false,
        false,
        true,
        true
      ]
    ],
    [
      "REST API та вебхуки",
      [
        false,
        false,
        true,
        true
      ]
    ],
    [
      "SAML",
      [
        false,
        false,
        false,
        true
      ]
    ],
    [
      "SLA та окрема підтримка",
      [
        false,
        false,
        false,
        true
      ]
    ],
    [
      "Варіант on-premise",
      [
        false,
        false,
        false,
        true
      ]
    ]
  ],
  "pages": {
    "home": {
      "title": "sign.yt: електронний підпис на вашому домені",
      "desc": "Платформа електронного підпису для офісів, коворкінгів і бухгалтерських фірм: власний домен і брендинг, печатка PAdES, перевірка підписантів через SMS та email.",
      "h1": "Договори, підписані під вашим іменем.",
      "lead": "sign.yt проводить увесь процес підписання на вашому домені, з вашим логотипом і вашим відправником листів. Підписанти підтверджують особу кодом з email або SMS, а кожен PDF повертається з печаткою PAdES і повним журналом аудиту."
    },
    "hub": {
      "title": "Функції електронного підпису: домени, PAdES, API",
      "desc": "Усе, що вміє sign.yt: власні домени, брендинг, PAdES, позначки часу, закріплення в Bitcoin, постквантова печатка, перевірка за QR, API та інструменти GDPR.",
      "h1": "Усе, що потрібно, щоб документи були підписані",
      "lead": "Кожна функція нижче вже є в продукті. Оберіть будь-яку, щоб побачити, як вона працює."
    },
    "pricing": {
      "title": "Ціни на електронний підпис: тарифи в PLN",
      "desc": "Місячні тарифи на електронний підпис у PLN: {plans}, Enterprise за запитом. Ціни нетто + ПДВ, тариф можна змінити будь-коли.",
      "h1": "Тарифи, що ростуть разом із вашими офісами",
      "lead": "Місячні ціни нетто в PLN. Почніть з малого і переходьте вище, коли знадобляться власні домени, SSO чи API."
    }
  },
  "labels": {
    "home": "Головна",
    "features": "Функції",
    "pricing": "Ціни",
    "faq": "Поширені запитання",
    "month": "міс.",
    "custom": "Індивідуально",
    "contact": "Зв'язатися з відділом продажів",
    "verify": "Перевірити документ",
    "all": "Усі функції",
    "more": "Інші функції",
    "language": "Мова",
    "breadcrumb": "Навігаційний ланцюжок",
    "not_found_title": "Сторінку не знайдено",
    "not_found_lead": "Сторінка, яку ви шукаєте, не існує або була переміщена.",
    "back_home": "На головну"
  },
  "ui": {
    "skip": "Перейти до вмісту",
    "nav_label": "Головне меню",
    "features": "Функції",
    "pricing": "Ціни",
    "faq": "Запитання",
    "verify": "Перевірити документ",
    "developers": "Розробникам і API",
    "language": "Мова",
    "sign_in": "Увійти",
    "book_demo": "Замовити демо",
    "dashboard": "Перейти до панелі",
    "menu": "Меню",
    "footer_blurb": "Електронний підпис на вашому домені, з вашим брендингом і вашим відправником листів. Створено для офісів, коворкінгів і бухгалтерських фірм.",
    "footer_product": "Продукт",
    "footer_company": "Компанія",
    "footer_legal": "Правова інформація",
    "all_features": "Усі функції",
    "contact": "Контакти",
    "status": "Статус",
    "privacy": "Політика конфіденційності",
    "terms": "Умови користування",
    "dpa": "Договір про обробку даних",
    "subprocessors": "Субпроцесори",
    "rodo": "Запитати мої дані (GDPR)",
    "faq_title": "Поширені запитання",
    "cta_title": "Подивіться на прикладі ваших документів",
    "cta_lead": "Замовте коротке демо, і ми налаштуємо тестову організацію з вашим доменом і брендингом.",
    "not_found_title": "Сторінку не знайдено",
    "not_found_lead": "Сторінка, яку ви шукаєте, не існує або була переміщена.",
    "back_home": "На головну",
    "home": "Головна",
    "breadcrumb": "Навігаційний ланцюжок",
    "feature_kicker": "Функція",
    "more_features": "Інші функції",
    "see_all": "Усі функції",
    "see_pricing": "Переглянути ціни",
    "read_more": "Докладніше",
    "per_month": "PLN / міс.",
    "net_note": "нетто + ПДВ",
    "custom_price": "Індивідуально",
    "custom_note": "Ціна під ваші обсяги",
    "recommended": "Рекомендуємо",
    "choose_plan": "Обрати",
    "contact_sales": "Зв'язатися з відділом продажів",
    "compare_kicker": "Пліч-о-пліч",
    "compare_title": "Порівняння тарифів",
    "feature_col": "Функція",
    "included": "Включено",
    "not_included": "Не включено",
    "scroll_hint": "Гортайте вбік, щоб порівняти всі тарифи",
    "dev_title": "Почніть інтеграцію",
    "dev_lead": "Повний довідник API, швидкий старт за п’ять хвилин і офіційні SDK для Python і TypeScript.",
    "dev_reference": "Довідник API",
    "dev_quickstart": "Швидкий старт",
    "dev_sdks": "SDK",
    "copy": "Копіювати",
    "copied": "Скопійовано",
    "pricing_faq_title": "Запитання щодо оплати",
    "not_found_try": "Можливо, ви шукали",
    "lang_suggest": "Ця сторінка доступна також українською.",
    "lang_switch": "Читати українською",
    "lang_dismiss": "Ні, дякую"
  },
  "examples": {
    "api": {
      "log": "Доставки вебхуків",
      "target": "crm.example.pl/hooks/sign"
    },
    "audit": {
      "ok": "Ланцюг цілий",
      "rows": [
        [
          "Документ створено",
          "anna@example.pl"
        ],
        [
          "Надіслано підписанту",
          "jan@example.pl"
        ],
        [
          "Відкрито",
          "83.12.x.x · Firefox"
        ],
        [
          "SMS-код підтверджено",
          "+48 600 *** 412"
        ],
        [
          "Підписано",
          "83.12.x.x · 09:33:10"
        ]
      ]
    },
    "bitcoin": {
      "file": "pidpysano.pdf",
      "block": "Блок",
      "ok": "Закріплено"
    },
    "bulk": {
      "docs": "4 документи",
      "progress": "Підписано 2 з 4",
      "st": {
        "signed": "Підписано",
        "viewed": "Переглянуто",
        "sent": "Надіслано"
      }
    },
    "domains": {
      "title": "Власний домен",
      "type": "Тип",
      "name": "Назва",
      "target": "Вказує на",
      "status": "Статус",
      "verified": "Перевірено",
      "tls": "Сертифікат TLS випущено",
      "doc": "Договір оренди, офіс 2.14",
      "sign": "Підписати",
      "host": "sign.vashafirma.com"
    },
    "templates": {
      "search": "Пошук шаблонів",
      "fields": "полів",
      "items": [
        [
          "Оренда офісу",
          "Оренда",
          9
        ],
        [
          "NDA, взаємна",
          "Право",
          4
        ],
        [
          "Додаток до договору",
          "Оренда",
          5
        ],
        [
          "Маркетингова згода",
          "GDPR",
          2
        ]
      ]
    },
    "email": {
      "title": "Поштовий провайдер",
      "from": "Відправник",
      "test": "Тестовий лист доставлено",
      "managed": "Керований"
    },
    "gdpr": {
      "req": "Запит суб'єкта даних",
      "exp": "Експорт",
      "erase": "Видалення",
      "steps": [
        "Особу підтверджено",
        "Зібрано дані з 3 документів",
        "Підписані договори збережено, законний строк зберігання"
      ],
      "zip": "Завантажити ZIP",
      "foot": "Хостинг у ЄС · AES-256-GCM на диску"
    },
    "mobile": {
      "title": "Ваш підпис",
      "sign": "Підписати",
      "left": "Залишилося 1 з 2 полів"
    },
    "pades": {
      "valid": "Підпис дійсний",
      "signer": "Підписав",
      "format": "Формат",
      "time": "Час підписання",
      "intact": "Не змінено після підписання",
      "file": "dohovir-pidpysano.pdf"
    },
    "pz": {
      "steps": [
        "Перегляд",
        "Метод",
        "Підпис"
      ],
      "choose": "Оберіть спосіб підписання",
      "opts": [
        [
          "Profil Zaufany",
          "Безкоштовно, через login.gov.pl"
        ],
        [
          "e-dowód",
          "ID-картка з NFC"
        ],
        [
          "Кваліфікований підпис",
          "Надавач довірчих послуг"
        ]
      ],
      "btn": "Підписати через Profil Zaufany",
      "note": "Вас буде перенаправлено до Węzeł Podpisu"
    },
    "smart": {
      "nip": "NIP орендаря",
      "fetched": "Знайдено в реєстрах",
      "name": "Назва компанії",
      "addr": "Юридична адреса",
      "vat": "Статус ПДВ",
      "active": "Активний платник ПДВ, ПДВ ЄС дійсний",
      "gen": "Згенерувати договір"
    },
    "sms": {
      "title": "Підтвердіть, що це ви",
      "sent": "Ми надіслали 6-значний код на",
      "email": "Email",
      "resend": "Надіслати код повторно через 0:42",
      "go": "Перейти до документа"
    },
    "brand": {
      "doc": "Договір про надання послуг",
      "sign": "Підписати",
      "from": "від"
    }
  },
  "home": {
    "get_started": "Почати",
    "hero_line1": "Договори, підписані",
    "hero_line2": "під вашим іменем.",
    "hero_sub": "sign.yt проводить увесь процес підписання на вашому домені, з вашим логотипом і вашим відправником листів. Підписанти підтверджують особу кодом з email або SMS, а кожен PDF повертається з печаткою PAdES і повним журналом аудиту.",
    "cta_demo_sign_in": "Увійти",
    "cta_view_signing": "Переглянути сторінку підписання",
    "cta_see_pricing": "Переглянути ціни",
    "cta_start_free": "Почати безкоштовний пробний період",
    "nav_features": "Функції",
    "nav_pricing": "Ціни",
    "nav_plans": "Тарифи",
    "nav_contact": "Контакти",
    "cta_book_demo": "Замовити демо",
    "plans_title": "Платіть за документи, а не за підписантів.",
    "plans_sub": "Ціни в PLN нетто + ПДВ, оплата щомісяця. Підписанти ніколи не платять і не потребують облікового запису.",
    "plans_note": "Кожен тариф включає PDF з печаткою PAdES, хостинг у ЄС і повний журнал аудиту.",
    "tier_contact_cta": "Зв'язатися з нами",
    "contact_title": "Поговорімо про ваші документи",
    "contact_sub": "Розкажіть, що ви підписуєте, приблизно скільки документів на місяць і який домен хочете використовувати. Ми відповімо з часом для демо та тестовою організацією.",
    "contact_email_cta": "Написати нам",
    "contact_response_time": "Зазвичай ми відповідаємо протягом одного робочого дня.",
    "footer_company": "Компанія",
    "features_title": "Усе, що потрібно для підписання, і нічого зайвого",
    "features_sub": "Створено для команд, які щодня надсилають договори і хочуть, щоб вони виглядали як їхні власні.",
    "feature_custom_domains_title": "Власні домени",
    "feature_custom_domains_body": "Кожен клієнт на власному брендованому піддомені. Ключова функція, якої не пропонує жоден великий гравець.",
    "feature_pades_title": "Підписи PAdES",
    "feature_pades_body": "PDF, підписані у форматі PAdES (ETSI EN 319 142).",
    "feature_dev_first_title": "Для розробників",
    "feature_dev_first_body": "Повний REST API, вебхуки, SDK, MCP-сервер для AI-агентів.",
    "feature_wezel_title": "Готовність до Węzeł Podpisu",
    "feature_wezel_body": "Нативна інтеграція з Węzeł Podpisu (польський державний сервіс підписання): Profil Zaufany, e-dowód, кваліфікований підпис, mObywatel.",
    "feature_rodo_title": "GDPR / RODO за замовчуванням",
    "feature_rodo_body": "Експорт даних за статтею 20, анонімізація за статтею 17, хеш-ланцюг журналу аудиту, хостинг у Польщі.",
    "feature_i18n_title": "5 мов одразу",
    "feature_i18n_body": "Англійська, польська, українська, німецька, іспанська. Додавайте нові мови під час роботи, без нового релізу.",
    "feature_api_title": "API насамперед",
    "feature_api_body": "Усе, що є в інтерфейсі, є і в REST API. Специфікація OpenAPI автоматично публікується на api.sign.yt.",
    "pricing_title": "Чесні ціни, прозорі ліміти",
    "pricing_sub": "Щомісячна оплата. Без доплати за підпис для перших 500 документів. Скасування будь-коли.",
    "tier_starter": "Starter",
    "tier_starter_blurb": "Для одного офісу, який тільки починає.",
    "tier_starter_b1": "50 документів / міс.",
    "tier_starter_b2": "3 користувачі, 1 команда",
    "tier_starter_b3": "Керована пошта, одноразовий код з email",
    "tier_starter_cta": "Спробувати Starter",
    "tier_pro": "Professional",
    "tier_pro_blurb": "Для команд, яким потрібен власний домен.",
    "tier_pro_b1": "500 документів / міс.",
    "tier_pro_b2": "10 користувачів, 5 команд",
    "tier_pro_b3": "Власний домен, без водяного знака",
    "tier_pro_b4": "Одноразові коди SMS (50 / міс.)",
    "tier_pro_cta": "Почати з Pro",
    "tier_business": "Business",
    "tier_business_blurb": "Для операторів із кількома брендами.",
    "tier_business_b1": "Необмежена кількість документів",
    "tier_business_b2": "Необмежена кількість користувачів і команд",
    "tier_business_b3": "SSO, вебхуки, API-ключі, власна пошта",
    "tier_business_b4": "Пріоритетна підтримка",
    "tier_business_cta": "Поговорити з відділом продажів",
    "tier_enterprise": "Enterprise",
    "tier_enterprise_blurb": "Для індивідуальних договорів і on-premise.",
    "tier_enterprise_b1": "Усе з тарифу Business",
    "tier_enterprise_b2": "SAML SSO, SLA, DPA",
    "tier_enterprise_b3": "Окремий інженер із супроводу",
    "tier_enterprise_cta": "Зв'язатися з нами",
    "most_popular": "Рекомендуємо",
    "pln_per_month": "PLN / міс.",
    "custom": "Індивідуально",
    "trust_eu_hosted": "Хостинг у ЄС",
    "trust_pades": "Печатка PAdES",
    "trust_rodo": "GDPR / RODO",
    "trust_audit": "Хеш-ланцюг аудиту",
    "who_title": "Для тих, хто підписує найбільше",
    "who_sub": "Три типи команд, під які ми створили sign.yt.",
    "segment_biura_title": "Віртуальні офіси та коворкінги",
    "segment_biura_body": "Договори оренди та надання послуг, підписані на вашому домені під вашим брендом. Кожен бренд працює як окрема організація з власним доменом, а один вхід дає змогу перемикатися між ними.",
    "segment_kancelarie_title": "Юридичні та бухгалтерські фірми",
    "segment_kancelarie_body": "Договори про надання послуг і згоди з запечатаним PDF і журналом аудиту, який можна зберігати в справі клієнта.",
    "segment_hr_title": "HR-команди",
    "segment_hr_body": "Оферти, NDA та додатки, надіслані масово із шаблонів, з окремим відстеженням кожного підписанта.",
    "faq_title": "Поширені запитання",
    "faq_q1": "Чи мають ці підписи юридичну силу?",
    "faq_a1": "Так. Згідно з eIDAS, електронний підпис не можна відхилити як доказ лише тому, що він електронний. sign.yt запечатує кожен підписаний PDF (PAdES) і веде журнал аудиту: хто підписав, коли і як пройшов перевірку. Для документів, що потребують сильнішої форми, підписанти можуть використати Profil Zaufany (польський державний профіль eID), якщо його ввімкнено.",
    "faq_q2": "Чи можна використовувати власний домен і відправника листів?",
    "faq_a2": "Так. З тарифу Professional можна додати домен для підписання, наприклад sign.vashafirma.com, з автоматичним сертифікатом TLS. З тарифу Business листи також можуть надсилатися через ваш власний SMTP, Microsoft 365, Resend, Amazon SES або Mailgun, тож запрошення надходять з вашої адреси.",
    "faq_q3": "Як підписанти підтверджують свою особу?",
    "faq_a3": "Ви обираєте для кожного документа: без додаткового кроку, одноразовий код з email або одноразовий код з SMS. Використаний метод фіксується в журналі аудиту.",
    "faq_q4": "Чи є API?",
    "faq_a4": "Так. REST API з API-ключами з обмеженими правами дає змогу створювати та надсилати документи з вашої системи, а вебхуки повідомляють, коли документ переглянуто, підписано чи завершено.",
    "final_cta_title": "Ваші клієнти підписують. Визнання отримуєте ви.",
    "final_cta_sub": "Замовте коротке демо, і ми налаштуємо тестову організацію з вашим брендингом.",
    "footer_tag": "Електронний підпис на вашому домені.",
    "footer_product": "Продукт",
    "footer_developers": "Розробникам",
    "footer_legal": "Правова інформація",
    "footer_privacy": "Конфіденційність",
    "footer_terms": "Умови",
    "footer_made_in_pl": "Зроблено в Польщі",
    "footer_made_with": "Зроблено з",
    "footer_in_poland_by": "у Польщі командою",
    "hero_kicker": "Електронний підпис для офісів, фірм і HR-команд",
    "hero_note": "Ціни від 49 PLN / міс. нетто + ПДВ. Хостинг у ЄС.",
    "cta_dashboard": "Перейти до панелі",
    "how_kicker": "Як це працює",
    "how_title": "Від PDF до запечатаного договору за п'ять кроків",
    "step1_title": "Завантажте PDF",
    "step1_body": "Додайте договір або почніть зі збереженого шаблону. Розумні документи можуть заповнити дані компанії з GUS, VIES і білого списку платників ПДВ за податковим номером.",
    "step2_title": "Розмістіть поля",
    "step2_body": "Перетягніть на сторінку поля підпису, дати, тексту та прапорці й призначте їх кожному одержувачу. Оберіть паралельне або послідовне підписання.",
    "step3_title": "Надішліть зі свого домену",
    "step3_body": "Запрошення надходять від вашого власного відправника листів, а посилання на підпис відкривається на sign.vashafirma.com з вашим брендингом.",
    "step4_title": "Підписант проходить перевірку",
    "step4_body": "Перед підписанням одержувачі підтверджують особу одноразовим кодом з email або SMS. Якщо це увімкнено, вони також можуть підписати через Profil Zaufany.",
    "step5_title": "Запечатаний PDF і журнал аудиту",
    "step5_body": "Фінальний PDF має печатку PAdES, яку може перевірити будь-хто, а також журнал аудиту, де кожна подія пов'язана з попередньою хешем.",
    "features_kicker": "Функції",
    "features_all": "Усі функції ({n})",
    "bento_domains_title": "Власні домени",
    "bento_domains_body": "Посилання на підпис відкриваються на sign.vashafirma.com. Один запис CNAME, сертифікат TLS випускається автоматично.",
    "bento_pades_title": "Печатка PAdES",
    "bento_pades_body": "Криптографічна печатка на кожному PDF, а також журнал аудиту з хеш-ланцюгом.",
    "bento_verify_title": "Знайте, хто підписав",
    "bento_verify_body": "Коди з email або SMS, а також Profil Zaufany (польський державний профіль eID), e-dowód (польська електронна ID-картка) чи mObywatel (польський державний мобільний застосунок ID) через Węzeł Podpisu (польський державний сервіс підписання), якщо це ввімкнено.",
    "bento_smart_title": "Розумні документи",
    "bento_smart_body": "Введіть податковий номер, і дані компанії заповняться з GUS, VIES і білого списку платників ПДВ.",
    "bento_api_title": "REST API та вебхуки",
    "bento_api_body": "Створюйте та надсилайте документи з власної системи й отримуйте сповіщення, коли їх підписано.",
    "who_kicker": "Для кого",
    "plans_kicker": "Ціни",
    "plans_compare": "Порівняти тарифи",
    "plans_per_month": "PLN / міс. нетто + ПДВ",
    "security_kicker": "Безпека та відповідність",
    "security_title": "Створено, щоб витримати аудит",
    "trust_eu_hosted_body": "Дані та документи залишаються на серверах у Європейському Союзі.",
    "trust_pades_body": "Підписані PDF можна перевірити в будь-якій стандартній програмі або через QR-код і коротке посилання на кожному документі.",
    "trust_rodo_body": "Запити на експорт і видалення даних вбудовані в продукт, а не обробляються листуванням.",
    "trust_audit_body": "Захищений від підробки журнал кожного перегляду, перевірки та підпису.",
    "faq_kicker": "Запитання",
    "faq_q5": "Які мови підтримуються?",
    "faq_a5": "Застосунок і сторінки підписання доступні англійською, польською, українською, німецькою та іспанською.",
    "faq_q6": "Де зберігаються мої дані?",
    "faq_a6": "На серверах у Європейському Союзі. Ви можете експортувати або видалити персональні дані на запит, як того вимагає GDPR.",
    "contact_kicker": "Контакти",
    "bento_brand_title": "Ваш бренд, а не наш",
    "bento_brand_body": "Логотип, кольори, чотири теми сторінок і шаблони листів. Команди можуть мати власний вигляд на сторінках підписання, сторінках перевірки та в листах.",
    "cta_show_demo": "Показати демо",
    "demo_note": "Без реєстрації. Приватна пісочниця зі зразками договорів, яка видаляється автоматично."
  }
}

export default pack
